var exports = {
  "k": "xe564cbfb--23254f--container",
};

module.exports = exports;
